import { MulitiReflection } from './muliti-reflection'
import { UserDomainEnum } from './user-domain-enum'

export interface UserInterface {
  token?: string
  /**
   * 刷新 token
   */
  refreshToken?: string
  /**
   * token 过期时间
   */
  expiredAt?: string
  /**
   * 当根据用户信息查询到多个用户时，本字段不为空，需要用户页面选择使用哪个登录
   */
  reflections?: MulitiReflection[] | null
  /**
   * 是否需要短信验证码二次验证
   *  - 使用密码登录+使用新设备登录
   *  - 使用密码登录+当天密码连续错误3次
   */
  openMsgCheck?: boolean
  redirectUri?: string | null
  rid: number
  /**
   * 用户所属领域
   */
  domain: UserDomainEnum
  /**
   * 用户名
   */
  name: string
  /**
   * 账户
   */
  account: string
  /**
   * 用户所属学校 id
   */
  schoolId?: number | null
  /**
   * 手机号
   */
  phone?: string | null
  /**
   * 头像
   */
  avator?: string | null
  /**
   * 用户身份【目前仅前台用户使用】
   */
  role?: string | null
  /**
   * 用户状态【目前仅前台用户使用】
   */
  status?: string | null
  /**
   * 用户学工号【目前仅前台用户使用】
   */
  usin?: string | null
  /**
   * 用户归档时【目前仅前台用户使用】
   */
  archivedAt?: string | null
}

export class User implements UserInterface {
  token?: string
  /**
   * 刷新 token
   */
  refreshToken?: string
  /**
   * token 过期时间
   */
  expiredAt?: string
  /**
   * 当根据用户信息查询到多个用户时，本字段不为空，需要用户页面选择使用哪个登录
   */
  reflections?: MulitiReflection[] | null
  /**
   * 是否需要短信验证码二次验证
   *  - 使用密码登录+使用新设备登录
   *  - 使用密码登录+当天密码连续错误3次
   */
  openMsgCheck?: boolean
  redirectUri?: string | null
  rid: number
  /**
   * 用户所属领域
   */
  domain: UserDomainEnum
  /**
   * 用户名
   */
  name: string
  /**
   * 账户
   */
  account: string
  /**
   * 用户所属学校 id
   */
  schoolId?: number | null
  /**
   * 手机号
   */
  phone?: string | null
  /**
   * 头像
   */
  avator?: string | null
  /**
   * 用户身份【目前仅前台用户使用】
   */
  role?: string | null
  /**
   * 用户状态【目前仅前台用户使用】
   */
  status?: string | null
  /**
   * 用户学工号【目前仅前台用户使用】
   */
  usin?: string | null
  /**
   * 用户归档时【目前仅前台用户使用】
   */
  archivedAt?: string | null

  constructor(props: UserInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      token: _token,
      refreshToken: _refreshToken,
      expiredAt: _expiredAt,
      reflections: _reflections,
      openMsgCheck: _openMsgCheck,
      redirectUri: _redirectUri,
      rid: _rid,
      domain: _domain,
      name: _name,
      account: _account,
      schoolId: _schoolId,
      phone: _phone,
      avator: _avator,
      role: _role,
      status: _status,
      usin: _usin,
      archivedAt: _archivedAt,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.token = _token
    this.refreshToken = _refreshToken
    this.expiredAt = _expiredAt
    this.reflections = _reflections
      ? _reflections.map((i) => new MulitiReflection(i))
      : _reflections
    this.openMsgCheck = _openMsgCheck
    this.redirectUri = _redirectUri
    this.rid = _rid
    this.domain = _domain
    this.name = _name
    this.account = _account
    this.schoolId = _schoolId
    this.phone = _phone
    this.avator = _avator
    this.role = _role
    this.status = _status
    this.usin = _usin
    this.archivedAt = _archivedAt
  }
}
